import React from 'react'
import productTabsData from './tabs-data'

const NutritionFacts = ({ nutrition }: any) => {
  return (
    <div className="w-[240px] border border-brand-dark p-1  text-brand-dark">
      <header className="text-center border-b-8 border-brand-dark">
        <h1 className="font-bold text-3xl leading-7">Nutrition Information</h1>
        <p className="text-xs">Serving Size 1 Piece</p>
      </header>
      <ul className="text-xs mt-3 font-medium">
        <li className="border-b-[.8px] border-brand-dark text-[10px]">
          Amount Per Serving
        </li>
        {nutrition.map(([key, value]) => (
          <li className="flex justify-between border-b-[.8px] border-brand-dark leading-6">
            <strong>{key}</strong>
            <span>{value}</span>
          </li>
        ))}
      </ul>
      <div className="text-[8px] mt-2 mt-2 font-medium">
        <p>
          * Percent Daily Values are based on a 2,000 calorie diet. Your daily
          values may be higher or lower depending on your calorie needs:
        </p>
        <table className="w-full mt-2 leading-4">
          <tbody>
            {productTabsData.nutritionFacts2.map(
              (
                item: { title: string; compare?: string; value: string },
                index: number,
              ) => (
                <tr
                  className={
                    index === 0 ||
                    index === productTabsData.nutritionFacts2.length - 1
                      ? 'border-b-[.5px] border-brand-dark'
                      : ''
                  }
                >
                  <td colSpan={2} className="text-left">
                    {item.title}
                  </td>
                  <td>{item.compare}</td>
                  <td className="text-center">{item.value}</td>
                </tr>
              ),
            )}
          </tbody>
        </table>
        <p className="mt-3">Calories per gram:</p>

        <p className="text-center mt-2">Fat 9 • Carbohydrate 4 • Protein 4</p>
      </div>
    </div>
  )
}

export default NutritionFacts
